import { createRouter } from 'vue-router';
import { createWebHistory } from 'vue-router';
import routes from '@/router/routes';
var router = createRouter({
    // Use router with web history mode
    history: createWebHistory(process.env.BASE_URL),
    // Use routes
    routes: routes,
});
// Export router instance
export default router;
